import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import DepositPaymentRecivedBanner from 'assets/images/DepositPaymentRecivedBanner.png';
import { postApiCall } from 'api/apiService';
import { POST_BUYER_BANNER_CLOSE } from 'constant/app.config';

const DepositPaymentReceivedBannerBuyer = (props) => {
  const {
    isBuyerDashboard,
    buyerDashboardDetails,
    getBuyerIndividualValue,
    DashboardGroupCall,
    groupIt,
    setDepostPaymentReceviedClose,
  } = props;
  const theme = useTheme();

  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const DepositPaymentAmount = isBuyerDashboard
    ? buyerDashboardDetails?.depositPaymentAmount
    : getBuyerIndividualValue?.PropertyDetails?.depositPaymentAmount;

  const [closeLoader, setCloseLoader] = useState(false);
  const handleBuyerDepositRecivedCloseApiCall = async () => {
    const propertyId = isBuyerDashboard
      ? buyerDashboardDetails?.property?.propertyId
      : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;
    let input = {
      propertyId: propertyId,
      bannerCode: 'BUYER004',
      bannerHeading: 'Deposit payment Recived banners',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_BUYER_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        setDepostPaymentReceviedClose((prev) =>
          prev.includes(propertyId) ? prev : [...prev, propertyId]
        );
        if (!isBuyerDashboard) {
          groupIt();
        }
        if (isBuyerDashboard) {
          DashboardGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={9} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    marginTop: matchessm ? '-40px' : '-10px',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                    mt: matchessm ? '-6px' : 1,
                  }}
                >
                  Deposit Payment Received
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  Thank you,{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {isBuyerDashboard
                      ? [
                          buyerDashboardDetails?.agentDetails?.agentName,
                          buyerDashboardDetails?.agentDetails?.agentSurName,
                        ]
                          .filter(Boolean)
                          .join(' ')
                      : [
                          getBuyerIndividualValue?.PropertyDetails?.agentDetails
                            ?.agentName,
                          getBuyerIndividualValue?.PropertyDetails?.agentDetails
                            ?.agentSurName,
                        ]
                          .filter(Boolean)
                          .join(' ')}
                    &nbsp;
                  </Typography>
                  has confirmed your deposit payment &nbsp;
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {DepositPaymentAmount ?? ''} &nbsp;
                  </Typography>
                  has been received for
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    &nbsp;
                    {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName ||
                      buyerDashboardDetails?.propertyAddress?.streetName}
                  </Typography>
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    disabled={closeLoader}
                    onClick={handleBuyerDepositRecivedCloseApiCall}
                    endIcon={closeLoader && <CircularProgress size="20px" />}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                  >
                    Close
                  </Button>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={DepositPaymentRecivedBanner}
                alt="Deposit Payment Request Recive"
                style={{ objectFit: 'contain', height: '265px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default DepositPaymentReceivedBannerBuyer;
